import React, { useState, useEffect, useRef, useCallback } from 'react';
import 'swiper/css';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useToast } from '../../Utils/toastContext';
import { useSelector, useDispatch } from 'react-redux';
import Dropdown from '../../Components/CustomDropdown/customdropdown';
import { debounce } from 'lodash';
import { changeCustomerTabTrue } from '../../Redux/store/selectedCard';
import countriesData from '../../Data/CountryCodes.json';
import CustomDropdownWithFetch from '../../Components/CustomDropdown/custom-dropdown-fetchAPI';
import PermissionSection from '../../Components/Permissions/permission-section';
import PermissionSectionDisabled from '../../Components/Permissions/permission-section-disabled';
import { setCustomerNameRedux } from '../../Redux/store/userSlice';
import {
  clearOnboardingCustomer,
  setOnboardingCustomer,
} from '../../Redux/store/onboardingFormSlice';
import CertificatePdfViewer from './certificate-pdf-viewer';
import GeoRiskMap from '../../Components/addressInput/map-view';
import MindmapTree from '../../Components/Onbaording/onboarding-tree';
import { formatDateTimeUTC } from '../../Constants/helper-functions';

const validator = require('validator');
const CheckItem = ({ label, status }) => {
  const styles = {
    pass: 'bg-emerald-50 text-emerald-700 border-emerald-100',
    fail: 'bg-red-50 text-red-700 border-red-100',
    warn: 'bg-amber-50 text-amber-700 border-amber-100',
  };

  const icons = {
    pass: '✔',
    fail: '✖',
    warn: '⚠',
  };

  return (
    <div
      className={`flex justify-between items-center p-3 rounded-xl border shadow-sm ${styles[status]} transition hover:shadow-md`}
    >
      <span className="text-xs font-medium text-gray-800">{label}</span>

      <span className="text-xs font-semibold flex items-center gap-1">
        {icons[status]} {status.toUpperCase()}
      </span>
    </div>
  );
};
const CustomerDetails = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const getReviewPath = (accountType, userId) => {
    if (accountType >= 1 && accountType <= 5) {
      return `/review-kyc/${userId}`;
    }

    if ([6, 7, 8].includes(accountType)) {
      return `/review-kyc-corporate/${userId}`;
    }

    if ([9, 10, 11].includes(accountType)) {
      return `/review-kyc-trust/${userId}`;
    }

    return `/review-kyc/${userId}`; // fallback
  };
  const getInitials = (name) => {
    if (!name) return '?';
    return name.trim().charAt(0).toUpperCase();
  };

  const getAvatarStyle = (name) => {
    const styles = [
      'bg-[#EEF2FF] text-[#3730A3] ring-1 ring-[#E0E7FF]', // Indigo soft
      'bg-[#F1F5F9] text-[#334155] ring-1 ring-[#E2E8F0]', // Slate
      'bg-[#FDF2F8] text-[#9D174D] ring-1 ring-[#FBCFE8]', // Rose subtle
      'bg-[#F0FDF4] text-[#166534] ring-1 ring-[#BBF7D0]', // Green subtle
      'bg-[#FFFBEB] text-[#92400E] ring-1 ring-[#FDE68A]', // Amber subtle
    ];

    const index = name?.charCodeAt(0) % styles.length;
    return styles[index];
  };
  const getReviewPathReadOnly = (accountType, userId) => {
    if (accountType >= 1 && accountType <= 5) {
      return `/review-kyc/read-only/${userId}`;
    }

    if ([6, 7, 8].includes(accountType)) {
      return `/review-kyc-corporate/read-only/${userId}`;
    }

    if ([9, 10, 11].includes(accountType)) {
      return `/review-kyc-trust/read-only/${userId}`;
    }

    return `/review-kyc/read-only/${userId}`; // fallback
  };
  const [data, setData] = useState([
    {
      name: 'Harbourgate Property Investments Pty Ltd',
      type: 'Corporate',
      children: [
        { name: 'Ann', type: 'Individual', children: [] },
        {
          name: 'Comm Bank Pty LTD',
          type: 'Corporate',
          children: [
            {
              name: 'Oceanview Capital Holdings Pty Ltd',
              type: 'Corporate',
              children: [
                {
                  name: 'Emily Johanson',
                  type: 'Individual',
                  children: [],
                },
                { name: 'Dalia limited', type: 'Corporate', children: [] },
                { name: 'Noah', type: 'Individual', children: [] },
              ],
            },
            { name: 'Aron', type: 'Individual', children: [] },
          ],
        },
        { name: 'Carol', type: 'Trust', children: [] },
      ],
    },
    {
      name: 'Harbourgate Family Trust',
      type: 'Trust',
      children: [
        {
          name: 'Harbourgate Trustees Pty Ltd',
          type: 'Corporate',
          children: [
            { name: 'James Alexander', type: 'Individual', children: [] },
            { name: 'Jane Smith', type: 'Individual', children: [] },
          ],
        },
        { name: 'Cayman Holdings Trust', type: 'Trust', children: [] },
      ],
    },
    {
      name: 'Emma Johnson',
      type: 'Individual',
      children: [],
    },
  ]);
  const cardCurrencyName = useSelector((state) => state.user.cardCurrencyName);
  const location = useLocation();
  const loggedInUserRole = useSelector((state) => state.user.roleName);
  const [accountTypeData, setAccountTypeData] = useState([]);
  const dispatch = useDispatch();
  const buttonRefs = useRef({});
  const roleName = useSelector((state) => state.user.roleName);
  const [pdfCertificate, setPdfCertificate] = useState(null);
  const customerName = useSelector((state) => state.user.customerName);
  const { from, componentName, advisorId } = location.state || {};
  const [countries, setCountries] = useState([]);
  const [accessLevelOptions, setAccessLevelOptions] = useState([]);
  const [mobileNumber, setMobileNumber] = useState('');
  const [focus, setFocus] = useState(false);
  const [selectedCode, setSelectedCode] = useState('+61');
  const navigate = useNavigate();
  const [isOpenEdit, setisOpenEdit] = useState(false);
  const customerTab = useSelector((state) => state.cards.customerTab);
  const [loading, setLoading] = useState(false);
  const [isModalOpenProfileEdit, setIsModalOpenProfileEdit] = useState(false);
  const [newFirstName, setNewFirstName] = useState('');
  const [newLastName, setNewLastName] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [customerType, setCustomerType] = useState('');
  const [newCity, setNewCity] = useState('');
  const [newState, setNewState] = useState('');
  const [newAddress, setNewAddress] = useState('');
  const [newZipCode, setNewZipCode] = useState('');
  const [certificates, setCertificates] = useState([]);
  const [showVisualLink, setShowVisualLink] = useState(false);
  useEffect(() => {
    setCountries(countriesData);
  }, []);
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  function setCountryCodeEdit(countryCode) {
    const match = countryCodeData.find((c) => c.value === countryCode);
    if (match) {
      setpreselectedCountryCode({
        value: match.value,
        label: match.label,
      });
    } else {
      // Optional: set a default if no match found
      setpreselectedCountryCode({
        value: '',
        label: '',
      });
    }
  }
  const handleEditClickProfile = () => {
    setIsModalOpenProfileEdit(true);
    setNewFirstName(profileData.first_name);
    setNewLastName(profileData.last_name);
    setNewEmail(profileData.email_address);
    setMobileNumber(profileData.mobile_number);
    setSelectedCode(profileData.country_code);
    if (addressData.country != null) {
      setpreselectedCountryCodeProfile({
        value: addressData.country.id,
        label: addressData.country.name,
      });
      setCountryCodeProfile(addressData.country.id);
    }
    if (addressData.city != null) {
      setpreselectedCity({
        value: addressData.city.id,
        label: addressData.city.name,
      });
      setNewCity(addressData.city.id);
    }

    if (addressData.state != null) {
      setpreselectedState({
        value: addressData.state.id,
        label: addressData.state.name,
      });
      setNewState(addressData.state.id);
    }
    setNewZipCode(addressData.zip_code);
    setNewAddress(addressData.google_address);
  };
  const togglePopupEdit = () => {
    setisOpenEdit(!isOpenEdit);
    setcurrentPassword('');
    setnewPassword('');
    setconfirmPassword('');
    setShowConfirmPassword(false);
    setShowCurrentPassword(false);
    setShowNewPassword(false);
  };
  const [showconfirmPassword, setShowConfirmPassword] = useState(false);
  const [confirmPassword, setconfirmPassword] = useState('');
  const [showcurrentPassword, setShowCurrentPassword] = useState(false);
  const [currentpassword, setcurrentPassword] = useState('');
  const [shownewPassword, setShowNewPassword] = useState(false);
  const [newPassword, setnewPassword] = useState('');
  const [profileData, setprofileData] = useState({});
  const [addressData, setAddressData] = useState(null);
  const searchParams = new URLSearchParams(location.search);
  const cardId = searchParams.get('cardId');
  const { customerId } = useParams();
  const [filter, setFilter] = useState(cardId ? 'accounts' : customerTab);
  const [countryCode, setCountryCode] = useState('AU');
  const [countryCodeProfile, setCountryCodeProfile] = useState('');
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({
    value: 'AU',
    label: 'Australia',
  });
  const [preselectedCountryCodeProfile, setpreselectedCountryCodeProfile] =
    useState({});
  const [preselectedCity, setpreselectedCity] = useState({});
  const [preselectedState, setpreselectedState] = useState({});
  const [permissions, setPermissions] = useState({});
  const [chunks, setChunks] = useState([]);

  useEffect(() => {
    if (Object.keys(permissions).length > 0) {
      const sectionEntries = Object.entries(permissions);
      const chunkSize = 3;
      const newChunks = [];

      for (let i = 0; i < sectionEntries.length; i += chunkSize) {
        newChunks.push(sectionEntries.slice(i, i + chunkSize));
      }
      setChunks(newChunks);
    }
  }, [permissions]);
  const getAllUserPermissions = async () => {
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(`/v1/permissions/user/${customerId}`);

      if (response.status == 200) {
        setPermissions(response.data.permissions);
      } else {
        if (response.status === 400) {
          setPermissions([]);
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
      setPermissions([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    }
  };
  const getAllAdviorUserPermissions = async () => {
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(
        `/v1/permissions/advisors/${advisorId}/customers/${customerId}/permissions`,
      );

      if (response.status == 200) {
        setPermissions(response.data.permissions);
      } else {
        if (response.status === 400) {
          setPermissions([]);
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
      setPermissions([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    }
  };
  const getAllSubAdviorUserPermissions = async () => {
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(
        `/v1/permissions/sub-advisors/${advisorId}/customers/${customerId}/permissions`,
      );

      if (response.status == 200) {
        setPermissions(response.data.permissions);
      } else {
        if (response.status === 400) {
          setPermissions([]);
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
      setPermissions([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    }
  };
  const requestReviewAPI = async (levelId) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/agency/certificates/customers/${customerId}/request-access-upgrade`;
    let bodyData = {
      requested_level: levelId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleSelectAccessLevel = async (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    let toastMessage = null;
    try {
      const response = await requestReviewAPI(selectedOption.value);
      if (response.status == 200) {
        toastMessage = {
          message: response.message,
          type: 'success',
        };
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300);
      }
    }
  };
  const formatDate = (dateString) => {
    return dateString.split(' ')[0];
  };
  // Handles ISO strings ("2026-09-16T01:12:50.158068Z") from the certificate
  // payload as well as legacy "dd/mm/yyyy hh:mm AM/PM" strings
  const toDisplayDate = (dateString) => {
    if (!dateString) return '-';
    if (dateString.includes('T')) {
      const [year, month, day] = dateString.split('T')[0].split('-');
      return `${day}/${month}/${year}`;
    }
    return formatDate(dateString);
  };
  const getAccessLevels = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/reference/access-levels`);

      if (response.status == 200) {
        const AccountData = [];
        AccountData.push({
          value: response.data.access_levels[1].id,
          label: 'View KYC',
        });
        AccountData.push({
          value: response.data.access_levels[2].id,
          label: 'Edit KYC',
        });
        setAccessLevelOptions(AccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          setAccessLevelOptions([]);
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
      setAccessLevelOptions([]);
    }
  };

  const buildPayload = () => {
    let payload = [];

    // Loop through each section (account, bank, etc.)
    Object.values(permissions).forEach((section) => {
      section.forEach((perm) => {
        payload.push({
          unique_id: perm.unique_id,
          allowed: perm.status, // status → allowed
          // valid_from: "2020-05-01",   // optional
          // valid_until: "2026-06-01"  // optional
        });
      });
    });

    return payload;
  };
  const updatePermission = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/permissions/user/update`;

    const bodyData = {
      user_id: customerId,
      permissions: buildPayload(),
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleUpdatePermissions = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updatePermission();
        if (response.status == 200) {
          getAllUserPermissions();
          toastMessage = {
            message: 'Details updated successfully.',
            type: 'success',
          };
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [customerId, permissions], // Dependencies
  );
  const updatePermissionAdvisor = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/permissions/advisors/${advisorId}/customers/${customerId}/permissions/update`;

    const bodyData = {
      permissions: buildPayload(),
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleUpdatePermissionsAdvisor = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updatePermissionAdvisor();
        if (response.status == 200) {
          if (componentName == 'advisor') {
            getAllAdviorUserPermissions();
          }
          if (componentName == 'sub-advisor') {
            getAllSubAdviorUserPermissions();
          }
          toastMessage = {
            message: 'Details updated successfully.',
            type: 'success',
          };
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [customerId, permissions, advisorId], // Dependencies
  );
  const [isLoading, setIsLoading] = useState(false);
  const [countryCodeData, setCountryCodeData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [countryData, setCountryData] = useState([]);

  const handleSelectCountryCode = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    setCountryCode(selectedOption.value);
  };
  const handleSelectCountryCodeProfile = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    setCountryCodeProfile(selectedOption.value);
    setStateData([]);
    setCityData([]);
    setpreselectedCity({});
    setpreselectedState({});
  };
  const handleSelectCity = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    setNewCity(selectedOption.value);
    setpreselectedCity(selectedOption);
  };
  const handleSelectState = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    setNewState(selectedOption.value);
    setpreselectedState(selectedOption);
  };
  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  const editProfile = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/user/profile/update/${customerId}`;
    const bodyData = {
      first_name: newFirstName,
      last_name: newLastName,
      country_code: selectedCode,
      mobile_number: mobileNumber,
      email_address: newEmail,
      type: customerType,
      address: {
        city_id: newCity,
        country_id: countryCodeProfile,
        state_id: newState,
        zip_code: newZipCode,
        google_address: newAddress,
      },
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleEditProfile = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await editProfile();
        if (response.status == 200) {
          setIsModalOpenProfileEdit(false);
          getprofileData();
          toastMessage = {
            message: 'Details updated successfully.',
            type: 'success',
          };
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      newFirstName,
      newLastName,
      selectedCode,
      mobileNumber,
      newEmail,
      customerType,
      newCity,
      countryCodeProfile,
      newState,
      newZipCode,
      newAddress,
    ], // Dependencies
  );
  const getAllCountries = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/users/countries?size=1000`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.countries.forEach((item) => {
          AllAccount.push({
            value: item.id,
            label: item.name,
          });
        });

        setCountryData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      setCountryData([]);
      setpreselectedCountryCode({});
      handleSelectCountryCode({});
      showToast(err.message, 'error');
    }
  };
  const getCities = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 20; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/v1/user/cities/${countryCodeProfile}?page=${page}&size=${size}&search=${
          searchTerm || ''
        }`,
      );

      if (response.status === 200) {
        const items = response.data.cities.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        return {
          items,
          hasMore: response.data.cities.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, 'error');
      return { items: [], hasMore: false };
    }
  };
  const getStates = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 20; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/v1/user/states/${countryCodeProfile}?page=${page}&size=${size}&search=${
          searchTerm || ''
        }`,
      );

      if (response.status === 200) {
        const items = response.data.states.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        return {
          items,
          hasMore: response.data.states.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, 'error');
      return { items: [], hasMore: false };
    }
  };
  const toggleConfirmPassword = () => {
    setShowConfirmPassword((prevState) => !prevState);
  };

  const toggleCurrentPassword = () => {
    setShowCurrentPassword((prevState) => !prevState);
  };
  const toggleNewPassword = () => {
    setShowNewPassword((prevState) => !prevState);
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const getprofileData = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agency' || roleName == 'agency_compliance'
          ? `/api/v1/agency/customers/${customerId}`
          : `/api/v1/agent/customers/${customerId}`,
      );

      if (response.status == 200) {
        setprofileData(response.data);
        setAddressData(response.data.address);
        // Certificates are embedded in the customer payload (no separate list endpoint):
        // prefer the all_active array, fall back to the single `certificate` object.
        const activeCertificates =
          Array.isArray(response.data.all_active) &&
          response.data.all_active.length > 0
            ? response.data.all_active
            : response.data.certificate
              ? [response.data.certificate]
              : [];
        setCertificates(activeCertificates);
        dispatch(
          setCustomerNameRedux(
            response.data.first_name + ' ' + response.data.last_name,
          ),
        );
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          setprofileData({});
          showToast(response.message, 'error');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click happened outside all dropdowns
      const isOutside = !Object.values(buttonRefs.current).some((ref) =>
        ref?.contains(event.target),
      );
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);
  function formatDateTime(dateString) {
    if (!dateString) return '-';

    try {
      // remove timezone abbreviations like AEDT, AEST etc.
      const cleaned = dateString.replace(/\b[A-Z]{3,4}\b/g, '').trim();

      const parts = cleaned.split(' ');
      const [day, month, year] = parts[0].split('/');

      let [hour, min, sec] = parts[1].split(':');
      const period = parts[2];

      hour = parseInt(hour);

      // convert 12h → 24h
      if (period === 'PM' && hour !== 12) hour += 12;
      if (period === 'AM' && hour === 12) hour = 0;

      return `${day}/${month}/${year}`;
    } catch (e) {
      return '-';
    }
  }
  const handleToggle = (section, id) => {
    setPermissions((prev) => ({
      ...prev,
      [section]: prev[section].map((perm) =>
        perm.unique_id === id ? { ...perm, status: !perm.status } : perm,
      ),
    }));
  };
  useEffect(() => {
    if (filter === 'profile') {
      getprofileData();
      getAllCountries();
      getAccessLevels();
    }
  }, [filter, componentName, advisorId, cardCurrencyName]);
  const UpdatePassword = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/dashboard/change-password/${customerId}`;
    const bodyData = {
      old_password: currentpassword,
      new_password: newPassword,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleUpdatePassword = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;

      try {
        const response = await UpdatePassword();

        if (response.status == 200) {
          togglePopupEdit();
          toastMessage = {
            message: 'Password Updated successfully',
            type: 'success',
          };
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [currentpassword, newPassword, confirmPassword], // Dependencies
  );
  return (
    <div className="w-full  pt-4">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      {/* Summary Cards */}
      {filter !== 'banks' && isLoading ? (
        <div className="shimmer-container-list mb-4 ">
          {/* Creating 5 rows of shimmer effect */}
          {[...Array(2)].map((_, rowIndex) => (
            <div key={rowIndex} className="shimmer-row-list">
              {/* Creating 7 cells in each row for shimmer */}
              {[...Array(2)].map((_, colIndex) => (
                <div key={colIndex} className="shimmer-cell-list h-20">
                  <div className="shimmer-loader"></div>
                </div>
              ))}
            </div>
          ))}
        </div>
      ) : (
        <div></div>
      )}

      {filter == 'profile' && (
        <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
          <div className="w-full p-4 bg-white rounded-lg shadow-lg">
            {/* Header Section */}
            <div className="flex w-full flex-col md:flex-row justify-between items-start md:items-center border-b pb-5 border-gray-100 gap-3">
              {/* LEFT: TITLE */}
              <div className="flex items-center gap-3">
                <img
                  src="/profile-circle-black.svg"
                  alt="Company Logo"
                  className="w-6 h-6"
                />
                <span className="font-medium lg:text-xl text-sm">
                  Customer Details
                </span>
              </div>

              {/* RIGHT SIDE WRAPPER */}
              <div className="flex flex-col md:flex-row md:items-center gap-4 md:ml-auto">
                {/* DROPDOWN */}
                {profileData.access_level != null &&
                  profileData.access_level?.id != 3 && (
                    <div className="md:ml-2">
                      <Dropdown
                        label=""
                        options={accessLevelOptions}
                        onSelect={handleSelectAccessLevel}
                        placeholder="Request more access"
                      />
                    </div>
                  )}

                {/* MEMBER SINCE */}
                <p className="text-sm flex items-center gap-2">
                  <span className="font-medium text-labelLightColour">
                    Member since:
                  </span>
                  <span className="font-medium text-black">
                    {formatDateTimeUTC(profileData.created_at)}
                  </span>
                </p>
              </div>
            </div>
            {/* Profile Section */}
            <div className="flex w-full flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
              {/* Profile Picture */}
              <div className="relative flex-shrink-0 mb-4 lg:mb-0 mt-1 mr-6">
                {profileData?.profile_picture?.presigned_url ? (
                  <img
                    src={profileData.profile_picture?.presigned_url}
                    alt={`${profileData.first_name}`}
                    className="w-20 h-20 rounded-full object-cover"
                  />
                ) : (
                  <div
                    className={`w-20 h-20 flex items-center justify-center rounded-full font-semibold text-sm ${getAvatarStyle(
                      profileData.first_name,
                    )}`}
                  >
                    {getInitials(profileData.first_name)}
                  </div>
                )}
                {profileData.status?.label == 'active' && (
                  <div className="absolute top-2 left-16 w-3 h-3 bg-[#75E380] rounded-full"></div>
                )}
                {profileData.status?.label == 'rejected' && (
                  <div className="absolute top-2 left-16 w-3 h-3 bg-[#FF5050] rounded-full"></div>
                )}
                <label htmlFor="investmentManagerFees" className="mt-2 text-xs">
                  <span className="text-[#A6A6A6]">Client No:</span>
                </label>
                <p className="text-black text-sm">{profileData.client_id}</p>
              </div>

              {/* Profile Details */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full ">
                {/* Column 1 */}
                <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                  <label
                    htmlFor="refId"
                    className="mb-1 text-xs text-[#A6A6A6]"
                  >
                    Status
                  </label>
                  <span className="text-sm">
                    {profileData.status?.label
                      .replace(/_/g, ' ')
                      .replace(/\b\w/g, (char) => char.toUpperCase())}
                  </span>
                  {profileData.type !== 'Corporate' && (
                    <>
                      <div className="mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-[#A6A6A6]"
                        >
                          First Name
                        </label>
                        <div className="text-sm">{profileData.first_name}</div>
                      </div>
                      <div className="mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-[#A6A6A6]"
                        >
                          Last Name
                        </label>
                        <div className="text-sm">{profileData.last_name}</div>
                      </div>
                    </>
                  )}
                  {profileData.type === 'Corporate' && (
                    <>
                      <div className="mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-[#A6A6A6]"
                        >
                          Company Name
                        </label>
                        <div className="text-sm">
                          {profileData.first_name} {profileData.last_name}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* Column 2 */}
                <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                  <label
                    htmlFor="investmentManagerFees"
                    className="mb-1 text-xs"
                  >
                    <span className="text-[#A6A6A6]">Phone</span>
                  </label>
                  <div className="text-sm">
                    {profileData.country_code}
                    {profileData.mobile_number}
                  </div>
                  {profileData.type !== 'Corporate' && (
                    <>
                      <label
                        htmlFor="investmentManagerFees"
                        className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                      >
                        Email
                      </label>
                      <span className="text-sm break-words">
                        {profileData.email_address}
                      </span>
                    </>
                  )}
                  <label
                    htmlFor="investmentManagerFees"
                    className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                  >
                    Type
                  </label>
                  <div className="text-sm">
                    {profileData.account_type?.name}
                  </div>
                </div>

                {/* Column 3 */}
                {(profileData?.access_level == null ||
                  profileData?.access_level?.id != 1) && (
                  <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                    <label
                      htmlFor="investmentManagerFees"
                      className="mb-1 text-xs"
                    >
                      <span className="text-[#A6A6A6]">
                        Onboarding application
                      </span>
                    </label>
                    {(profileData?.access_level == null ||
                      profileData?.access_level?.id != 1) && (
                      <button
                        onClick={() => {
                          if (
                            profileData?.access_level == null ||
                            profileData?.access_level?.id == 3
                          ) {
                            dispatch(setOnboardingCustomer(customerId));
                            const path = getReviewPath(
                              profileData.account_type_id,
                              customerId,
                            );
                            let redirectState = {
                              path: path,
                              state: {
                                from: location.pathname,
                                historyStack: [
                                  ...(location.state?.historyStack || []),
                                  location.pathname,
                                ],
                              },
                            };
                            sessionStorage.setItem(
                              'redirectAfterLogin',
                              JSON.stringify(redirectState),
                            );
                            navigate(path, {
                              state: {
                                from: location.pathname,
                                historyStack: [
                                  ...(location.state?.historyStack || []),
                                  location.pathname,
                                ],
                              },
                            });
                          }
                          if (profileData?.access_level?.id == 2) {
                            dispatch(
                              setOnboardingCustomer(profileData.user_id),
                            );
                            const path = getReviewPathReadOnly(
                              profileData.account_type_id,
                              customerId,
                            );
                            let redirectState = {
                              path: path,
                              state: {
                                from: location.pathname,
                                historyStack: [
                                  ...(location.state?.historyStack || []),
                                  location.pathname,
                                ],
                              },
                            };
                            sessionStorage.setItem(
                              'redirectAfterLogin',
                              JSON.stringify(redirectState),
                            );
                            navigate(path, {
                              state: {
                                from: location.pathname,
                                historyStack: [
                                  ...(location.state?.historyStack || []),
                                  location.pathname,
                                ],
                              },
                            });
                          }
                        }}
                        className="mt-4 py-3 w-40 bg-[#375AE7] text-white text-sm rounded-md hover:bg-gray-800"
                      >
                        View Details
                      </button>
                    )}
                  </div>
                )}

                {isOpenEdit && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg w-[90%] md:w-[700px] p-6">
                      {/* Modal Header */}
                      <div className="flex items-center justify-between mb-4">
                        <h2 className="text-lg font-medium text-center w-full">
                          Change Password
                        </h2>
                        <button onClick={togglePopupEdit}>
                          <img
                            src="/add.svg"
                            alt="Close"
                            className="w-10 h-10"
                          />
                        </button>
                      </div>

                      {/* Modal Body */}
                      <div className="grid grid-cols-1 gap-6 items-center">
                        <div className="space-y-4 mx-auto ">
                          <div className="mb-4 relative">
                            <label
                              htmlFor="password"
                              className="block text-labelColour dark:text-gray-300 font-normal text-sm mb-1"
                            >
                              Current password
                            </label>
                            <input
                              type={showcurrentPassword ? 'text' : 'password'}
                              value={currentpassword}
                              required={true}
                              id="currentpassword"
                              onChange={(e) =>
                                setcurrentPassword(e.target.value)
                              }
                              className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                              placeholder="Re-Type password"
                            />
                            <button
                              type="button"
                              onClick={toggleCurrentPassword}
                              className="absolute right-3 set-top"
                            >
                              {' '}
                              {showcurrentPassword ? (
                                <img
                                  src="/eye.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              ) : (
                                <img
                                  src="/eye-slash.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              )}
                            </button>
                          </div>
                          <div className="mb-4 relative">
                            <label
                              htmlFor="password"
                              className="block text-labelColour dark:text-gray-300 font-normal text-sm mb-1"
                            >
                              New password
                            </label>
                            <input
                              type={shownewPassword ? 'text' : 'password'}
                              value={newPassword}
                              required={true}
                              id="newpassword"
                              onChange={(e) => setnewPassword(e.target.value)}
                              className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                              placeholder="Re-Type password"
                            />
                            <button
                              type="button"
                              onClick={toggleNewPassword}
                              className="absolute right-3 set-top"
                            >
                              {' '}
                              {shownewPassword ? (
                                <img
                                  src="/eye.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              ) : (
                                <img
                                  src="/eye-slash.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              )}
                            </button>
                          </div>
                          <div className="mb-4 relative">
                            <label
                              htmlFor="password"
                              className="block color-test dark:text-gray-300 font-normal color-test text-md mb-1"
                            >
                              Repeat password
                            </label>
                            <input
                              type={showconfirmPassword ? 'text' : 'password'}
                              value={confirmPassword}
                              required={true}
                              id="confirmpassword"
                              onChange={(e) =>
                                setconfirmPassword(e.target.value)
                              }
                              className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                              placeholder="Re-Type password"
                            />
                            <button
                              type="button"
                              onClick={toggleConfirmPassword}
                              className="absolute right-3 set-top"
                            >
                              {' '}
                              {showconfirmPassword ? (
                                <img
                                  src="/eye.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              ) : (
                                <img
                                  src="/eye-slash.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              )}
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Modal Footer */}
                      <div className="flex justify-center space-x-4 mt-6">
                        <button
                          onClick={togglePopupEdit}
                          className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            if (newPassword.length < 8) {
                              showToast(
                                'Password must have At least 8 characters',
                                'error',
                              );
                              return;
                            }
                            if (!/(?=.*[0-9])/.test(newPassword)) {
                              showToast(
                                'Password must have At least 1 number',
                                'error',
                              );
                              return;
                            }
                            if (
                              !/(?=.*[!@#$%^&*()_+={}\[\]|:;"'<>,.?/`~\\/-])/.test(
                                newPassword,
                              )
                            ) {
                              showToast(
                                'Password must have At least 1 special character',
                                'error',
                              );
                              return;
                            }
                            if (!(
                              /(?=.*[a-z])/.test(newPassword) &&
                              /(?=.*[A-Z])/.test(newPassword)
                            )) {
                              showToast(
                                'Password must have Both upper and lower case characters',
                                'error',
                              );
                              return;
                            }
                            if (newPassword !== confirmPassword) {
                              showToast(
                                'Confirm password should be same as password',
                                'error',
                              );
                              return;
                            }
                            if (newPassword === currentpassword) {
                              showToast(
                                'New password should be different from current password',
                                'error',
                              );
                              return;
                            }
                            setLoading(true);

                            handleUpdatePassword(e);
                          }}
                          className="px-6 py-2 rounded-lg bg-[#375AE7] text-white hover:bg-gray-800"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {addressData && (
            <div className="pt-4 lg:flex mb-4 lg:space-x-4 gap-4">
              {/* LOCATION CARD */}
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 w-full lg:flex-[1.5]">
                {/* HEADER */}
                <div className="flex justify-between items-center border-b pb-3">
                  <div className="flex items-center space-x-3">
                    <span className="text-lg">📍</span>
                    <h3 className="text-sm font-semibold text-gray-800">
                      Location details
                    </h3>
                  </div>
                </div>

                {/* CONTENT */}
                <div className="grid md:grid-cols-1 gap-4 mt-4">
                  {/* PROVIDED ADDRESS (single-line from API) */}
                  <div className="p-4 rounded-xl bg-gray-50 border">
                    <p className="text-[11px] text-gray-500 mb-2">
                      PROVIDED ADDRESS
                    </p>

                    <div className="space-y-2 text-xs text-gray-700">
                      <div className="text-sm break-words">
                        {addressData?.google_address ||
                          [
                            addressData?.address_line_1,
                            addressData?.address_line_2,
                            addressData?.address_line_3,
                          ]
                            .filter(Boolean)
                            .join(', ')}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {certificates.length > 0 && (
            <div className="w-full p-4 bg-white rounded-lg shadow-lg lg:min-w-[78vw] lg:max-w-[80vw]">
              {/* Header */}
              <div className="text-center mb-6">
                <h2 className="text-xl font-medium text-gray-800">
                  Certificate(s)
                </h2>
                <div className="h-[1px] bg-gray-300 mt-2"></div>
              </div>

              {/* Main Certificate Card */}
              <div className="w-full">
                <div
                  className={`
      flex gap-4 pb-2
      ${certificates.length > 3 ? 'overflow-x-auto scrollbar-hide' : 'flex-wrap'}
    `}
                >
                  {certificates.map((card, index) => {
                    const isScrollable = certificates.length > 3;

                    return (
                      <div
                        key={card.id}
                        className={`
            bg-white text-slate-800 rounded-2xl p-6 border border-slate-200 shadow-[0_1px_2px_rgba(15,23,42,.04),0_16px_40px_-28px_rgba(15,23,42,.35)]

            ${
              isScrollable
                ? 'min-w-[300px] sm:min-w-[320px] md:min-w-[350px] flex-shrink-0'
                : certificates.length === 1
                  ? 'w-full'
                  : certificates.length === 2
                    ? 'w-full sm:w-[calc(50%-0.5rem)]'
                    : 'w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(33.33%-0.67rem)]'
            }
          `}
                      >
                        {/* Header */}
                        <div className="flex justify-between items-start mb-4">
                          <div>
                            <p className="text-xs text-slate-400">Issued By</p>
                            <h3 className="text-lg font-medium text-slate-800">
                              {[
                                card.issued_by?.first_name,
                                card.issued_by?.last_name,
                              ]
                                .filter(Boolean)
                                .join(' ')}
                            </h3>
                          </div>

                          <img
                            src="/Ratified-logo-blue.svg"
                            alt="logo"
                            className="w-14 h-14"
                          />
                        </div>

                        <div className="border-t border-slate-100 mb-4"></div>

                        {/* Content */}
                        <div className="flex justify-between items-center gap-3 flex-wrap">
                          {/* Date */}
                          <div>
                            <p className="text-xs text-slate-400">
                              Creation date
                            </p>
                            <p className="text-md font-medium text-slate-700">
                              {toDisplayDate(card.verification_date)}
                            </p>
                          </div>

                          {/* Status */}
                          <div>
                            <p className="text-xs text-slate-400">Status</p>
                            <div className="flex items-center gap-2">
                              <span
                                className={`material-symbols-outlined text-lg ${
                                  card.status.label === 'active'
                                    ? 'text-green-500'
                                    : 'text-red-500'
                                }`}
                              >
                                fiber_manual_record
                              </span>

                              <p className="text-md font-medium capitalize text-slate-700">
                                {card.status.label}
                              </p>
                            </div>
                          </div>

                          {/* View PDF — the only action */}
                          <button
                            type="button"
                            onClick={() => setPdfCertificate(card)}
                            className="inline-flex items-center gap-1.5 rounded-lg border border-[#375AE7]/30 bg-[#375AE7]/10 px-3 py-1.5 text-xs font-bold text-[#375AE7] transition-all hover:bg-[#375AE7] hover:text-white hover:shadow-md hover:shadow-[#375AE7]/30 active:scale-[0.97]"
                          >
                            <svg
                              width="13"
                              height="13"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2.2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              aria-hidden="true"
                            >
                              <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
                              <circle cx="12" cy="12" r="3" />
                            </svg>
                            View PDF
                          </button>
                        </div>

                        <div className="border-t border-slate-100 mt-4 mb-4"></div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* View-only PDF viewer */}
      <CertificatePdfViewer
        certificate={pdfCertificate}
        customerName={
          customerName ||
          `${profileData.first_name || ''} ${profileData.last_name || ''}`.trim()
        }
        onClose={() => setPdfCertificate(null)}
      />
    </div>
  );
};

export default CustomerDetails;
